import { useLocation } from '@tanstack/react-router';
import type { LinkProps } from '@tanstack/react-router';

import { Breadcrumbs } from '../../../cdl/Breadcrumbs/Breadcrumbs';
import { translate } from '../../../common/helpers/translate.helper';
import { useRole } from '../../../common/hooks/useRole';

import { getLubesDetailBreadcrumbLabel } from './getLubesDetailBreadcrumbLabel';

export const LubesRfqDetailBreadcrumb = () => {
    const location = useLocation();
    const role = useRole();
    const originLocation = location.state?.originLocation;
    const fallbackLabel = translate('navigation.requestsForQuotes');

    return (
        <Breadcrumbs
            links={[
                {
                    label: getLubesDetailBreadcrumbLabel(originLocation?.pathname, role.isSuperAdmin(), fallbackLabel),
                    linkOptions: {
                        to: originLocation?.pathname || '/requests-for-quotes',
                        search: originLocation?.search ?? { page: 0, tab: 'enquired' },
                    } as LinkProps,
                },
            ]}
        />
    );
};
